export const API_ACTIVITYLOG_TABLE = 'API_ACTIVITYLOG_TABLE';
export const API_ACTIVITYLOG_LIST = 'API_ACTIVITYLOG_LIST';
export const API_ACTIVITYLOG_UPSERT = 'API_ACTIVITYLOG_UPSERT';
export const API_ACTIVITYLOG_BY_USER = 'API_ACTIVITYLOG_BY_USER';
// Separate table action for /devrequests. It hits the same /ActivityLogs endpoint but
// needs its own store slot — sharing API_ACTIVITYLOG_TABLE would let the two pages
// overwrite each other's cached rows.
export const API_DEVREQUEST_TABLE = 'API_DEVREQUEST_TABLE';

export const activityLogsByUserId = (userId, model, clientId, options = {}) => {
  const {
    where: typeWhere, include: typeInclude, attributes: typeAttributes, ...remainingOptions
  } = options;
  const include = [
    {
      association: model.toLowerCase().substring(0, model.length - 1),
      where: {
        client_id: model === 'Contacts' ? clientId : undefined,
        ...typeWhere,
      },
      required: true,
      include: typeInclude,
      attributes: typeAttributes,
    },
  ];

  return {
    type: API_ACTIVITYLOG_BY_USER,
    id: `${model}_${userId}`,
    request: {
      url: '/ActivityLogs',
      method: 'GET',
      params: {
        opts: {
          attributes: [
            'object_id',
            { $max: { col: 'ActivityLogs.created_at', alias: 'last_viewed' } },
          ],
          where: {
            model,
            user_id: userId,
          },
          include,
          group: ['object_id'],
          limit: 10,
          offset: 0,
          ...remainingOptions,
          order: [['last_viewed', 'DESC']],
        },
      },
    },
  };
};

export const queryActivityLogLocationUpdates = (clientId, limit = 25, offset = 0) => ({
  type: API_ACTIVITYLOG_TABLE,
  request: {
    url   : '/LocationUpdates',
    method: 'GET',
    params: {
      selected_client_id: clientId,
      limit,
      offset,
    },
  },
});



export const queryActivityLogs = (options, type = API_ACTIVITYLOG_TABLE) => ({
  type,
  request: {
    url: '/ActivityLogs',
    method: 'GET',
    params: { opts: options },
  },
});

// Dev requests raised from the Key AI chat (send_dev_request). Admin-only page.
export const queryDevRequests = (options) => (
  queryActivityLogs(options, API_DEVREQUEST_TABLE)
);

export const API_DEVREQUEST_UPDATE = 'API_DEVREQUEST_UPDATE';

// Admin-only triage edit of a dev request's status/priority. Hits the narrow
// /DevRequestUpdate endpoint (NOT the generic PUT /ActivityLogs, which would rewrite the
// row's selected_client_id). `data` is { id, status? , priority? }.
export const updateDevRequest = (data) => ({
  type: API_DEVREQUEST_UPDATE,
  id: data.id,
  request: {
    url: '/DevRequestUpdate',
    method: 'PUT',
    data,
  },
});

export const listActivityLogs = () => (queryActivityLogs({
  order: [
    ['name', 'ASC'],
  ],
}, API_ACTIVITYLOG_LIST));

export const upsertActivityLog = (data) => {
  let options = null;
  let id = 0;

  if (data.id && data.id > 0) {
    id = data.id;
    options = {
      where: { id },
    };
  }

  return {
    type: API_ACTIVITYLOG_UPSERT,
    id,
    request: {
      url: '/ActivityLogs',
      method: 'PUT',
      params: { opts: options },
      data,
    },
  };
};
